export default "__VITE_ASSET__DSOtYlmc__"